module.exports = __webpack_public_path__ + "img/vocabulary_test_bg1.da42f1ca.png";